import React, { useEffect, useMemo, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { CATEGORIES, catByKey } from "../lib/api";

delete L.Icon.Default.prototype._getIconUrl;

const makeIcon = (color) =>
  L.divIcon({
    className: "agt-divicon",
    html: `<div class="agt-marker" style="background:${color}"></div>`,
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -18],
  });

export default function ShopMap({ shops, active, onToggle, height = "70vh" }) {
  const [ready, setReady] = useState(false);
  useEffect(() => { setReady(true); }, []);

  const filtered = useMemo(() => {
    if (!active || active.length === 0) return shops;
    return shops.filter((s) => active.includes(s.category));
  }, [shops, active]);

  return (
    <div className="relative" style={{ height }}>
      {ready && (
        <MapContainer center={[46.6, 2.5]} zoom={6} scrollWheelZoom style={{ height: "100%", width: "100%" }}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {filtered.map((s) => {
            const c = catByKey(s.category);
            return (
              <Marker key={s.id} position={[s.lat, s.lng]} icon={makeIcon(c.color)}>
                <Popup>
                  <div className="min-w-[220px] max-w-[280px]">
                    <span className="inline-block px-2 py-0.5 text-[0.65rem] font-bold uppercase tracking-wider rounded-full" style={{ background: c.color, color: c.key === "sports" ? "#243559" : "white" }}>{c.label}</span>
                    <h3 className="font-heading text-lg mt-2 leading-tight text-[var(--agt-navy)]">{s.name}</h3>
                    <p className="text-[11px] text-[var(--agt-ink-muted)] mt-1 uppercase tracking-widest font-bold">{s.city}</p>
                    <p className="text-sm text-[var(--agt-navy)] mt-2 leading-snug">{s.description}</p>
                    {s.website && (
                      <a
                        href={s.website}
                        target="_blank"
                        rel="noreferrer"
                        data-testid={`popup-website-${s.id}`}
                        className="inline-block mt-3 text-sm font-bold text-[var(--agt-mustard-deep)] hover:text-[var(--agt-navy)]"
                      >
                        Visiter →
                      </a>
                    )}
                  </div>
                </Popup>
              </Marker>
            );
          })}
        </MapContainer>
      )}

      <div className="absolute top-4 left-4 right-4 md:right-auto z-[1000] bg-white/95 backdrop-blur rounded-2xl px-4 py-3 border border-[var(--agt-line)] max-w-full md:max-w-md shadow-lg">
        <div className="eyebrow-navy mb-2 text-[0.6rem]">Filtrer par catégorie</div>
        <div className="flex flex-wrap gap-1.5">
          {CATEGORIES.map((c) => {
            const isActive = active.includes(c.key);
            return (
              <button
                key={c.key}
                data-testid={`map-filter-${c.key}`}
                onClick={() => onToggle(c.key)}
                className="chip"
                style={{
                  borderColor: c.color,
                  background: isActive ? c.color : "white",
                  color: isActive ? (c.key === "sports" ? "#243559" : "white") : c.color,
                }}
              >
                <span
                  className="w-1.5 h-1.5 rounded-full"
                  style={{ background: isActive ? (c.key === "sports" ? "#243559" : "white") : c.color }}
                />
                {c.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
